import { useEffect, useState } from 'react';
import { apiRequests } from '../../shared/api/apiRequests';
import { useParams } from 'react-router-dom';
import { CurrencyForm } from '../../features/CurrencyForm/CurrencyForm';

const EditCurrencyPage = () => {
  const [currencyData, setCurrencyData] = useState(null);
  const { id } = useParams();

  useEffect(() => {
    const getData = () => {
      apiRequests.currencies.getById(id).then((res) => {
        setCurrencyData(res);
      });
    };
    getData();
  }, [id]);

  if (!currencyData) return <div>Загрузка...</div>;

  return <CurrencyForm initialData={currencyData} isEdit={true} />;
};

export default EditCurrencyPage;
